const documentApi = {
    locationReload() {
        document.location.reload();
    },
    locationAssign(url) {
        document.location = url;
    },
    window,
};

export function useDocument() {
    return documentApi;
}
